import { DefaultError, useMutation } from '@tanstack/react-query';
import { useQueryToast } from 'hooks';
import i18next from 'i18next';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { ISalesChannelResponse } from './types';

export const usePostSalesChannelImage = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast(
    'usePostSalesChannelImage'
  );
  return useMutation<
    ISalesChannelResponse,
    DefaultError,
    { file: File; id: string }
  >({
    mutationFn: async ({ file, id }) => {
      loading(
        i18next.t('service-message.add.loading', {
          what: i18next.t('sales-channel.logo-what'),
        })
      );
      const formData = new FormData();

      formData.append('file', file);

      const response = await apiClient<FormData>({
        method: 'POST',
        url: `SalesChannel/UploadFile`,
        body: formData,
        params: { SalesChannelId: id },
        withContentType: false,
      });

      return responseHandler(response, {
        groupName: 'usePostSalesChannelImage',
        notFoundPath: '/sales-channel',
      });
    },
    onSuccess: () => {
      success(
        i18next.t('service-message.add.success', {
          what: i18next.t('sales-channel.logo-what'),
        })
      );
    },
    onError: dismiss,
  });
};
